//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { chargeCreateApi, clientCustomerSaveApi, chargeEditApi, chargeEditSubmitApi } from '@/api/enterprise';
export default {
  name: 'Index',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    oaForm: function oaForm() {
      return import('@/components/customer/oaForm');
    },
    addContract: function addContract() {
      return import('@/views/customer/contract/components/addContract');
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      fromInfo: [],
      row: {},
      types: 0,
      force: 0,
      contractFromData: {}
    };
  },
  methods: {
    // 新增客户表单
    getData: function getData() {
      var _this = this;
      chargeCreateApi().then(function (res) {
        _this.fromInfo = res.data;
      });
    },
    getEditData: function getEditData(id) {
      var _this2 = this;
      chargeEditApi(id).then(function (res) {
        _this2.fromInfo = res.data;
      });
    },
    handleClose: function handleClose() {
      this.fromInfo = [];
      this.row = {};
      this.drawer = false;
    },
    // 提交并继续添加合同
    addContinueOk: function addContinueOk(data) {
      this.submitOk(data, 1);
    },
    // 提交成功
    submitOk: function submitOk(data, type) {
      var _this3 = this;
      data.types = this.types;
      data.force = this.force;
      // 编辑客户信息
      if (this.row.id) {
        chargeEditSubmitApi(this.row.id, data).then(function (res) {
          if (res.status == 200) {
            if (type == 1) {
              _this3.contractFromData = {
                title: '添加合同',
                width: '570px',
                id: _this3.row.id
              };
              _this3.$refs.addContract.openBox();
              _this3.$refs.oaForm.resetForm();
            } else {
              _this3.drawer = false;
              _this3.$refs.oaForm.resetForm();
            }
            _this3.$emit('isOkEdit');
          } else {
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$refs.oaForm.addContractLoading = false;
          }
        }).catch(function (err) {
          // this.$refs.oaForm.resetForm()
        });
      } else {
        // 添加新客户
        clientCustomerSaveApi(data).then(function (res) {
          if (res.status == 200) {
            if (type == 1) {
              _this3.contractFromData = {
                title: '添加合同',
                width: '570px',
                id: res.data.id
              };
              _this3.$refs.addContract.openBox();
              _this3.$refs.oaForm.resetForm();
            } else {
              _this3.drawer = false;
              _this3.$refs.oaForm.resetForm();
            }
            _this3.$refs.oaForm.saveLoading = false;
            _this3.$emit('isOkEdit');
          } else {
            _this3.$refs.oaForm.saveLoading = false;
          }
        }).catch(function (err) {
          if (err.data.status == 2001) {
            _this3.$modalSure(err.data.message).then(function () {
              _this3.force = 1;
              _this3.submitOk(data, type);
              _this3.force = 0;
            });
            _this3.force = 0;
          }
          _this3.$refs.oaForm.saveLoading = false;
        });
      }
    },
    openBox: function openBox(type, row, str) {
      this.types = type;
      if (str === 'edit') {
        this.row = row;
        this.getEditData(row.id);
      } else {
        this.getData();
      }
      this.drawer = true;
    }
  }
};